/**
 * Searches a nested object for a given value and returns
 * the key path that leads to it.
 *
 * Example:
 *   findPathInNestedObject({ A: { B: 'x' } }, 'x')
 *   // => ['A', 'B']
 */
export default function findPathInNestedObject(
  obj: Record<string, any>,
  value: unknown,
  path: string[] = []
): string[] | undefined {
  return Object.keys(obj).reduce(
    (result: string[] | undefined, key: string) => {
      if (result !== undefined) return result;

      const currentPath = [...path, key];

      if (obj[key] === value) return currentPath;

      if (typeof obj[key] === 'object' && obj[key] !== null) {
        return findPathInNestedObject(obj[key], value, currentPath);
      }

      return undefined;
    },
    undefined
  );
}
